"use client";

import { useEffect, useState } from "react";
import ImageSlider from "./image-slider";

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative min-h-[90vh] pt-28 bg-white pb-32 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-primary/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-accent/10 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className={isVisible ? "animate-fade-in-up" : "opacity-0"}>
            <h1 className="text-5xl md:text-6xl font-bold leading-tight text-pretty mb-6">
              Master{" "}
              <span className="text-[var(--primary-color)]">Chemistry</span> for
              IIT JAM, JEE, GATE, NEET & NET
            </h1>
            <p className="text-xl text-muted-foreground mb-8 leading-relaxed">
              Learn from IIT Kanpur mentors with years of coaching experience.
              Comprehensive coverage, personalized guidance, and proven
              strategies to crack your exam.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button className="bg-[var(--primary-color)] text-white px-8 py-4 rounded-lg font-semibold hover:bg-primary/90 transition-all duration-300 hover:shadow-lg hover:scale-105">
                Enroll Now
              </button>
              <button className="border-2 border-primary text-primary px-8 py-4 rounded-lg font-semibold hover:bg-primary/5 transition-all duration-300">
                Contact Us
              </button>
            </div>
          </div>

          {/* Right Visual - CHANGE: Replaced with image slider */}
          <div
            className={`relative flex justify-center items-center  ${
              isVisible ? "animate-slide-in-left" : "opacity-0"
            }`}
          >
            <ImageSlider />
          </div>
        </div>
      </div>
    </section>
  );
}
